const MAX_UTM_FIELD_LENGTH = 255;

export const normalizeUtmValue = (value: string): string => {
  return value.slice(0, MAX_UTM_FIELD_LENGTH);
};
